import React, { createContext, useState } from 'react'
import AdminResetPassword from '../../Components/shared/AdminResetPassword'
import StudentInfo from '../../Components/shared/StudentInfo'
import PublipostageDrawer from '../../Components/institution/PublipostageDrawer'

export const Modes = Object.freeze({
  OPEN_SHEET: 1,
  RESET_PASSWORD: 2,
  PUBLIPOSTAGE: 3
})

export const DEFAULT_CONTEXT = {
  data: null,
  mode: null
}
export const StudentActionsContext = createContext()

const StudentActionsProvider = ({ children }) => {
  const [context, setContext] = useState(DEFAULT_CONTEXT)

  const handleClose = () => setContext(DEFAULT_CONTEXT)

  return (
    <>
      <StudentActionsContext.Provider
        value={{ setContext }}
      >
        {children}
      </StudentActionsContext.Provider>
      <StudentInfo student={context.mode === Modes.OPEN_SHEET ? context.data : null} onClose={handleClose} />
      <AdminResetPassword
        userToResetPassword={context.mode === Modes.RESET_PASSWORD ? context.data : null}
        onClose={handleClose}
      />
      <PublipostageDrawer
        student={context.mode === Modes.PUBLIPOSTAGE ? context.data : null}
        onClose={handleClose}
      />
    </>
  )
}

export default StudentActionsProvider
